export default "__VITE_ASSET__D0oULx19__"